import React from 'react'
import { motion } from 'framer-motion'
import { TabMenu } from '@demandlocal/components'
import { Navigate, Outlet, Route, Routes } from 'react-router-dom'
import VinSolutions from './Partners/VinSolutions'
import Eleads from './Partners/Eleads'
import CDK from './Partners/CDK'
import DealerSocket from './Partners/DealerSocket'
import Tekion from './Partners/Tekion'
import DriveCentric from './Partners/DriveCentric'
import DealerVault from './Partners/DealerVault'
import Procede from './Partners/Procede'

const AdminPartnersTemplate = (): JSX.Element => {
  return (
    <motion.div className={'flex flex-1 flex-col pb-8 font-Spartan'}>
      <TabMenu
        options={[
          { name: 'Vin Solutions', to: 'vinsolutions' },
          { name: 'Eleads', to: 'eleads' },
          { name: 'CDK', to: 'cdk' },
          { name: 'DealerSocket', to: 'dealersocket' },
          { name: 'Tekion', to: 'tekion' },
          { name: 'Drive Centric', to: 'drivecentric' },
          { name: 'Dealer Vault', to: 'dealervault' },
          { name: 'Procede', to: 'procede' },
        ]}
      />
      <Outlet />
    </motion.div>
  )
}

export default function AdminPartners(): JSX.Element {
  return (
    <Routes>
      <Route path="*" element={<AdminPartnersTemplate />}>
        <Route path="vinsolutions" element={<VinSolutions />} />
        <Route path="eleads" element={<Eleads />} />
        <Route path="cdk" element={<CDK />} />
        <Route path="dealersocket" element={<DealerSocket />} />
        <Route path="tekion" element={<Tekion />} />
        <Route path="drivecentric" element={<DriveCentric />} />
        <Route path="dealervault" element={<DealerVault />} />
        <Route path="procede" element={<Procede />} />
        <Route path="*" element={<Navigate to="vinsolutions" replace />} />
      </Route>
    </Routes>
  )
}
